export default function () {
    if (this.$route.params.id) {
        this.loadTrip()
    } else {
        this.resetPlace()
    }

    if (this.$route.params.clone) {
        this.loadTrip(this.$route.params.clone)
    }

    if (! this.trip.boardingPlaces.length) {
        this.addBoardingPlace()
    }

    if (! this.trip.accommodations.length) {
        this.addAccommodation()
    }

    this.loadAvailableAccommodations()
    this.loadAvailablePeopleTypes()
}
